// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"324":"6b4fd958","360":"6b4fd958","506":"6b4fd958","561":"6b4fd958","818":"b00556aa","909":"6b4fd958"}[chunkId] + ".chunk.css";
};